import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Shelter } from "@/types/shelter";

export const useShelters = () => {
  return useQuery({
    queryKey: ["shelters"],
    queryFn: async (): Promise<Shelter[]> => {
      const { data, error } = await supabase
        .from("shelters")
        .select("*")
        .order("name");

      if (error) {
        throw new Error(error.message);
      }

      // Map the data to ensure correct types
      return (data || []).map((shelter) => ({
        id: shelter.id,
        name: shelter.name,
        city: shelter.city,
        region: shelter.region,
        address: shelter.address,
        postal_code: (shelter as any).postal_code ?? null,
        lat: shelter.lat,
        lng: shelter.lng,
        phone: shelter.phone,
        email: shelter.email,
        website: shelter.website,
        current_needs: shelter.current_needs,
        urgent_needs: shelter.urgent_needs,
        urgent_needs_set_at: shelter.urgent_needs_set_at,
        dog_walking_available: shelter.dog_walking_available,
        volunteering_available: shelter.volunteering_available,
        dogs_available: shelter.dogs_available,
        cats_available: shelter.cats_available,
        volunteer_info: shelter.volunteer_info,
        description: shelter.description,
        last_updated: shelter.last_updated ?? shelter.created_at,
        created_at: shelter.created_at,
        data_verified: shelter.data_verified ?? false,
        organization_verified: (shelter as any).organization_verified ?? false,
        organization_verified_at: (shelter as any).organization_verified_at ?? null,
        organization_verification_pending: (shelter as any).organization_verification_pending ?? false,
        organization_verification_requested_at: (shelter as any).organization_verification_requested_at ?? null,
        contacted: (shelter as any).contacted ?? false,
      }));
    },
  });
};
